module.exports = __webpack_public_path__ + "static/img/close.5766e734.png";